import {register} from './../vendor/theme-scripts/theme-sections';
import openPhotoSwipe from '../util/open-photoswipe';

const sections = {};

const selectors = {
  videoPlay: '.image__video__play',
  dataHtml: 'data-html',
};

class ImageWithText {
  constructor(section) {
    this.container = section.container;
    this.id = section.id;
    this.videoPlay = this.container.querySelector(selectors.videoPlay);

    if (this.videoPlay) {
      this.videoPlay.addEventListener('click', function (e) {
        if (this.hasAttribute(selectors.dataHtml) && this.getAttribute(selectors.dataHtml).trim() !== '') {
          e.preventDefault();

          const items = [
            {
              html: this.getAttribute(selectors.dataHtml),
            },
          ];

          openPhotoSwipe(items);
        }
      });
    }
  }
}

const ImageWithTextSection = {
  onLoad() {
    sections[this.id] = new ImageWithText(this);
  },
  onUnload(e) {
    sections[this.id].onUnload(e);
  },
  onBlockSelect(e) {
    sections[this.id].onBlockSelect(e);
  },
};

register('image-with-text', ImageWithTextSection);
